(function () {
  const STORAGE_KEY = 'bulkx_wishlist_handles';
  const DEFAULT_LABELS = {
    addLabel: 'Toevoegen aan wensenlijst',
    removeLabel: 'Verwijderen uit wensenlijst',
    priceNote: 'Adviesprijs:',
    viewProduct: 'Bekijk product',
    saleLabel: 'KORTING'
  };
  const LABELS_BY_LOCALE = {
    nl: DEFAULT_LABELS,
    en: {
      addLabel: 'Add to wishlist',
      removeLabel: 'Remove from wishlist',
      priceNote: 'Suggested Retail Price:',
      viewProduct: 'View product',
      saleLabel: 'SALE'
    },
    de: {
      addLabel: 'Zur Wunschliste hinzufügen',
      removeLabel: 'Aus der Wunschliste entfernen',
      priceNote: 'UVP:',
      viewProduct: 'Produkt ansehen',
      saleLabel: 'RABATT'
    }
  };

  function getLocaleCode() {
    const lang = document.documentElement.getAttribute('lang') || '';
    return lang.toLowerCase().split('-')[0] || 'nl';
  }

  function getWishlistLabels() {
    const localeLabels = LABELS_BY_LOCALE[getLocaleCode()] || DEFAULT_LABELS;
    const labels = Object.assign({}, DEFAULT_LABELS, localeLabels);
    const section = document.querySelector('[data-bulkx-wishlist-section]');

    if (section) {
      labels.addLabel = section.dataset.bulkxWishlistAddLabel || labels.addLabel;
      labels.removeLabel = section.dataset.bulkxWishlistRemoveLabel || labels.removeLabel;
      labels.priceNote = section.dataset.bulkxWishlistPriceNote || labels.priceNote;
      labels.viewProduct = section.dataset.bulkxWishlistViewProduct || labels.viewProduct;
      labels.saleLabel = section.dataset.bulkxWishlistSaleLabel || labels.saleLabel;
    }

    return labels;
  }

  function getWishlist() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];

      if (!Array.isArray(parsed)) return [];

      return parsed.filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function setWishlist(handles) {
    const cleanHandles = Array.from(new Set(handles.filter(Boolean)));

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(cleanHandles));

    document.dispatchEvent(
      new CustomEvent('bulkx:wishlist:updated', {
        detail: {
          handles: cleanHandles
        }
      })
    );
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function addToWishlist(handle) {
    if (!handle) return;

    const wishlist = getWishlist();

    if (!wishlist.includes(handle)) {
      wishlist.push(handle);
    }

    setWishlist(wishlist);
  }

  function removeFromWishlist(handle) {
    if (!handle) return;

    const wishlist = getWishlist().filter(function (item) {
      return item !== handle;
    });

    setWishlist(wishlist);
  }

  function toggleWishlist(handle) {
    if (!handle) return;

    if (isInWishlist(handle)) {
      removeFromWishlist(handle);
    } else {
      addToWishlist(handle);
    }
  }

  function getProductUrl(handle) {
    return handle ? '/products/' + handle : '#';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return (Number(cents || 0) / 100).toLocaleString('nl-NL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function cleanMoney(value) {
    return String(value || '')
      .replace('€', '')
      .trim();
  }

  function updateWishlistButtons() {
    const wishlist = getWishlist();
    const labels = getWishlistLabels();

    document.querySelectorAll('[data-bulkx-wishlist-button]').forEach(function (button) {
      const handle = button.getAttribute('data-product-handle');

      if (!handle) return;

      const isActive = wishlist.includes(handle);

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.setAttribute('aria-label', isActive ? labels.removeLabel : labels.addLabel);
    });

    document.querySelectorAll('[data-bulkx-wishlist-count]').forEach(function (countElement) {
      countElement.textContent = wishlist.length;
    });
  }

  function bindWishlistButtons() {
    if (document.documentElement.dataset.bulkxWishlistButtonsReady === 'true') return;

    document.documentElement.dataset.bulkxWishlistButtonsReady = 'true';

    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-bulkx-wishlist-button]');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const handle = button.getAttribute('data-product-handle');

      toggleWishlist(handle);
      updateWishlistButtons();
      renderWishlistPage();
    });
  }

  async function fetchProductByHandle(handle) {
    const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Product not found: ' + handle);
    }

    return response.json();
  }

  function renderWishlistCard(product) {
    const labels = getWishlistLabels();
    const image = product.featured_image || '';
    const title = escapeHtml(product.title || '');
    const handle = escapeHtml(product.handle || '');
    const url = escapeHtml(product.url || getProductUrl(product.handle || ''));

    const price = Number(product.price || 0);
    const compareAtPrice = Number(product.compare_at_price || 0);

    const hasSale = compareAtPrice > price;
    const discount = hasSale ? Math.round(((compareAtPrice - price) * 100) / compareAtPrice) : 0;

    const currentPrice = cleanMoney(formatMoney(price));
    const comparePrice = hasSale ? cleanMoney(formatMoney(compareAtPrice)) : '';
    const infoPrice = hasSale ? comparePrice : currentPrice;

    return `
      <article class="bulkx-wishlist-card" data-bulkx-wishlist-card="${handle}">
        <div class="bulkx-wishlist-card__top">
          <div class="bulkx-wishlist-card__badges">
            ${
              hasSale
                ? `<span class="bulkx-wishlist-card__badge bulkx-wishlist-card__badge--sale">${discount}% ${escapeHtml(labels.saleLabel)}</span>`
                : ''
            }
          </div>

          <button
            type="button"
            class="bulkx-wishlist-card__remove"
            data-bulkx-wishlist-remove
            data-product-handle="${handle}"
            aria-label="${escapeHtml(labels.removeLabel)}"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M18.3 5.71L12 12.01L5.7 5.71L4.29 7.12L10.59 13.42L4.29 19.72L5.7 21.13L12 14.83L18.3 21.13L19.71 19.72L13.41 13.42L19.71 7.12L18.3 5.71Z"/>
            </svg>
          </button>
        </div>

        <a href="${url}" class="bulkx-wishlist-card__image-wrap" aria-label="${title}">
          ${
            image
              ? `<img src="${escapeHtml(image)}" alt="${title}" class="bulkx-wishlist-card__image" loading="lazy">`
              : `<div class="bulkx-wishlist-card__image-placeholder">${title}</div>`
          }
        </a>

        <div class="bulkx-wishlist-card__content">
          <a href="${url}" class="bulkx-wishlist-card__title">${title}</a>

          <div class="bulkx-wishlist-card__divider"></div>

          <div class="bulkx-wishlist-card__price-row">
            <div class="bulkx-wishlist-card__price-note">
              <span>${escapeHtml(labels.priceNote)}</span>
              <span>${escapeHtml(infoPrice)}</span>
            </div>

            <div class="bulkx-wishlist-card__price-box">
              <span class="bulkx-wishlist-card__price-current">${escapeHtml(currentPrice)}</span>

              ${
                hasSale
                  ? `<span class="bulkx-wishlist-card__price-compare">${escapeHtml(comparePrice)}</span>`
                  : ''
              }
            </div>
          </div>

          <a href="${url}" class="bulkx-wishlist-card__button">${escapeHtml(labels.viewProduct)}</a>
        </div>
      </article>
    `;
  }

  async function renderWishlistPage() {
    const container = document.querySelector('[data-bulkx-wishlist-grid]');
    const emptyState = document.querySelector('[data-bulkx-wishlist-empty]');
    const loadingState = document.querySelector('[data-bulkx-wishlist-loading]');

    if (!container) return;

    const handles = getWishlist();

    container.innerHTML = '';

    if (loadingState) {
      loadingState.hidden = false;
    }

    if (!handles.length) {
      if (loadingState) loadingState.hidden = true;
      if (emptyState) emptyState.hidden = false;
      return;
    }

    if (emptyState) {
      emptyState.hidden = true;
    }

    const products = [];

    for (const handle of handles) {
      try {
        const product = await fetchProductByHandle(handle);
        products.push(product);
      } catch (error) {
        console.warn(error);
      }
    }

    if (loadingState) {
      loadingState.hidden = true;
    }

    if (!products.length) {
      if (emptyState) emptyState.hidden = false;
      return;
    }

    container.innerHTML = products.map(renderWishlistCard).join('');
  }

  function bindWishlistPageRemove() {
    if (document.documentElement.dataset.bulkxWishlistRemoveReady === 'true') return;

    document.documentElement.dataset.bulkxWishlistRemoveReady = 'true';

    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-bulkx-wishlist-remove]');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const handle = button.getAttribute('data-product-handle');

      removeFromWishlist(handle);
      updateWishlistButtons();
      renderWishlistPage();
    });
  }

  function initWishlist() {
    bindWishlistButtons();
    bindWishlistPageRemove();
    updateWishlistButtons();
    renderWishlistPage();
  }

  document.addEventListener('DOMContentLoaded', initWishlist);

  document.addEventListener('shopify:section:load', function () {
    initWishlist();
  });

  document.addEventListener('bulkx:wishlist:updated', function () {
    updateWishlistButtons();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      updateWishlistButtons();
      renderWishlistPage();
    }
  });

  window.BulkxWishlist = {
    get: getWishlist,
    set: setWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist,
    render: renderWishlistPage,
    updateButtons: updateWishlistButtons
  };

  initWishlist();
})();
